export default __webpack_public_path__ + "static/media/profesor-circle.08d4a036.png";